<template>
<div class="">
    <div class="is-fullwidth is-clearfix has-margin-top-1 has-margin-bottom-0-5">
        <h3 class="is-size-5 is-uppercase has-text-weight-bold is-inline">Verwandte</h3>
        <button v-if="!toggleUpdateForm" class="button is-small is-primary has-margin-left-1 is-pulled-right" @click="showForm">
            <span class="has-margin-right-0-5" v-if="!toggleForm && !toggleUpdateForm">Neuer Verwandter</span>
            <span class="has-margin-right-0-5" v-if="toggleForm && !toggleUpdateForm">Formular schließen</span>
            <i v-if="!toggleForm && !toggleUpdateForm" class="fa fa-plus" title="Formular öffnen"></i>
            <i v-if="toggleForm && !toggleUpdateForm" class="fa fa-minus" title="Formular schließen"></i>
        </button>
        <button class="button is-small is-primary has-margin-left-1 is-pulled-right" @click="showUpdateForm" v-if="!toggleForm && toggleUpdateForm">
            <span class="has-margin-right-0-5">Formular schließen</span>
            <i class="fa fa-minus" title="Formular schließen"></i>
        </button>
    </div>
    <div class="has-margin-right-0-5" v-if="toggleForm">
        <div class="form is-fullwidth has-margin-bottom-1">
            <div class="field is-horizontal">
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <label for="name" class="label">Name</label>
                            <input class="input has-margin-right-1 input-padded" aria-label="Name" type="text" v-model="name" Placeholder="Name">
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <label for="birthday" class="label">Geburtstag</label>
                            <input class="input input-padded" aria-label="Geburtstag" v-pikaday v-model="birthday" value="">
                        </div>
                    </div>
                    <div class="field">
                        <div class="control is-expanded">
                            <label for="name" class="label">Typ</label>
                            <model-select :options="typeList"
                            v-model="type"
                            placeholder="Typ auswählen"
                            >
                            </model-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <label for="relative_description" class="label">Notiz</label>
                            <textarea name="relative_description" cols="65" rows="4" class="textarea" v-model="description"></textarea>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <label for="name" class="label">&nbsp;</label>
                            <button class="button is-primary" @click="submitForm">
                            Erstellen
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="has-margin-left-0-5 has-margin-right-0-5" v-if="toggleUpdateForm" >
            <div class="form is-fullwidth has-margin-bottom-1">
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label for="name" class="label">Name</label>
                                <input class="input has-margin-right-1 input-padded" aria-label="Name" type="text" v-model="updateName" Placeholder="Name">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label for="" class="label">Geburtstag</label>
                                <input class="input input-padded" aria-label="Geburtstag" v-pikaday v-model="updateBirthday">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control is-expanded">
                                <label for="name" class="label">Typ</label>
                                <model-select :options="typeList"
                                v-model="updateType"
                                placeholder="Typ auswählen"
                                >
                                </model-select>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label for="relative_description" class="label">Notiz</label>
                                <textarea name="relative_description" cols="65" rows="4" class="textarea" v-model="updateDescription"></textarea>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label for="name" class="label">&nbsp;</label>
                                <button class="button is-primary" @click="submitUpdateForm('relatives', updateId)">
                                Bearbeiten
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <ul class="is-fullwidth list has-margin-right-0-5">
            <li class="item has-padding-top-0-5 has-padding-bottom-0-5" v-for="relative in relatives" v-bind="relatives" v-bind:key="relative.id">
                <div class="columns is-multiline">
                    <div class="column is-12 is-3-tablet is-3-desktop">
                        <span class="is-size-7 is-uppercase has-text-weight-bold has-width-50">{{ relative.type }}</span>
                    </div>
                    <div class="column is-12 is-9-tablet is-9-desktop is-flex is-space-between">
                        <span>{{ relative.name }} <span v-if="relative.birthday" class="is-block-mobile">({{ formatToGerman(relative.birthday) }})</span></span>
                        <div>
                            <button class="button is-small" @click="deleteModel('relatives', relative.id)"><i class="fa fa-minus"></i></button>
                            <button class="button is-small" @click="editModel({modeltype: 'relative' ,type: relative.type, name: relative.name, id: relative.id, birthday: relative.birthday, description: relative.description})"><i class="fa fa-edit"></i></button>
                            <button v-if="relative.description" class="button is-small" @click="toggleItemDescription(relative.id)"><i class="fa fa-sticky-note"></i></button>
                        </div>
                    </div>
                    <transition name="fade">
                        <div class="column is-3" v-if="toggledRelative == relative.id">
                            <span class="has-width-50 is-size-7 is-uppercase has-text-weight-bold">Notiz</span>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div class="column is-9" v-if="toggledRelative == relative.id">
                            <span class="">{{ relative.description || '&nbsp;' }}</span>
                        </div>
                    </transition>
                </div>
            </li>
    </ul>
</div>
</template>

<script>
import Vue from 'vue'
import VueEvents from 'vue-events'
import { ModelSelect } from 'vue-search-select';
import moment from 'moment';
import V_Pikaday from '../../directives/pikaday';

Vue.use(VueEvents);

export default {
    components: {
        ModelSelect
    },
    beforeMount: function () {
    },
    props: ['model', 'relateableid', 'relateabletype', 'therelatives'],
    directives: {
         'pikaday': V_Pikaday
    },
    data: function() {
        return {
            toggleForm: false,
            toggleUpdateForm: false,
            name: '',
            birthday: '',
            type: '',
            description: '',
            updateDescription: '',
            updateName: '',
            updateBirthday: '',
            updateType: '',
            updateId: null,
            typeList: [
                {text: 'Vater', value: 'Vater'},
                {text: 'Mutter', value: 'Mutter'},
                {text: 'Sohn', value: 'Sohn'},
                {text: 'Tochter', value: 'Tochter'},
                {text: 'Ehepartner', value: 'Ehepartner'},
                {text: 'Lebensgefährte/in', value: 'Lebensgefährte/in'},
                {text: 'Bruder', value: 'Bruder'},
                {text: 'Schwester', value: 'Schwester'},
                {text: 'Grossvater', value: 'Grossvater'},
                {text: 'Grossmutter', value: 'Grossmutter'},
                {text: 'Stiefvater', value: 'Stiefvater'},
                {text: 'Stiefmutter', value: 'Stiefmutter'},
                {text: 'Stiefbruder', value: 'Stiefbruder'},
                {text: 'Stiefschwester', value: 'Stiefschwester'},
                {text: 'Tante', value: 'Tante'},
                {text: 'Onkel', value: 'Onkel'},
            ],
            relatives: JSON.parse(this.therelatives),
            toggledRelative: ''
        }
    },
    computed: {

    },
    methods: {
      toggleItemDescription(id) {
          if(this.$data.toggledRelative == id) return this.$data.toggledRelative = '';

          return this.$data.toggledRelative = id;
      },
      formatDate(datestring) {
        return (datestring !== '') ? moment(datestring).format('DD.MM.YYYY') : ''
      },
      formatToGerman(datestring) {
        if (datestring === '' || datestring === null) {
          return ''
        }
        let rawDate = datestring.substring(0,10).split('-');
        return rawDate[2] + '.' + rawDate[1] + '.' + rawDate[0]
      },
      formatBirthday(datestring) {
        if (datestring === '' || datestring == 'Invalid date') {
          return ''
        }

        let rawDate = datestring.substring(0, 10).split('.');
        let returnDate = rawDate[2] + '-' + rawDate[1] + '-' + rawDate[0];

        return returnDate;
      },
      submitForm() {
          axios.post(`/${this.model}/new`, {
              name: this.$data.name,
              relateable_id: this.relateableid,
              relateable_type: this.relateabletype,
              birthday: this.formatBirthday(this.$data.birthday),
              type: this.$data.type,
              description: this.$data.description
          }).then(res => {
              let data = res.data;
              this.relatives.push(data)
              this.toggleForm = false;

              this.$data.name = '';
              this.$data.birthday = '';
              this.$data.type = '';
              this.$data.description = '';

            }).catch(err => console.log(err))
        },
        submitUpdateForm(modeltype, id) {
            axios.put(`/${modeltype}/${id}`, {
              name: this.$data.updateName,
              birthday: this.formatBirthday(this.$data.updateBirthday),
              type: this.$data.updateType,
              description: this.$data.updateDescription,
              relateable_id: this.relateableid,
              relateable_type: this.relateabletype,
          }).then(res => {
              let filteredRelatives = this.relatives.filter((relative, index) => {
                  return relative.id !== res.data.id
              })

              filteredRelatives.push(res.data)

              this.relatives = filteredRelatives;
              this.toggleUpdateForm = false;
            })
        },
        showForm() {
            this.$data.birthday = this.formatDate(this.$data.birthday);
            this.$data.toggleForm = !this.$data.toggleForm;
        },
        showUpdateForm() {
            this.$data.updateBirthday = this.formatDate(this.$data.updateBirthday);
            this.$data.toggleUpdateForm = !this.$data.toggleUpdateForm;
        },
        deleteModel(model, modelid) {
          if(confirm('Sicher, dass Sie den/die Verwandte/n entfernen möchten?')) {
            axios.delete(`/${model}/${modelid}`).then(res => {
              this.relatives = this.relatives.filter(kid => {
                  return kid.id !== modelid;
              })
            })
          }
        },
        editModel(model) {
            this.$data.updateName = model.name
            this.$data.updateBirthday = model.birthday
            this.$data.updateType = model.type
            this.$data.updateId = model.id
            this.$data.updateDescription = model.description

            this.$data.toggleForm = false;
            return this.showUpdateForm()
        }
  }

}
</script>

<style scoped>
    .emspace {
        width: 1rem;
        display: inline-block;
    }
    .input-padded {
        padding: 0.67861429em 1em 0.67861429em 1em;
        height: 43px;
    }

    ul.list {
        width: 100%;
    }

    li.item {
        width: 100%;
        display: block;
        border-top: thin #dbdbdb solid;
    }

    span.has-width-50 {
        min-width: 40%;
        display: inline-block;
    }

    span.no-shrink {
        flex: 0 0 auto;
    }

    span.expand {
        flex: 1 0 auto;
        display: flex;
        justify-content: space-between;
    }

    .item.inner-container,
    .item .description {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .item .description {
        justify-content: flex-start;
    }

    .fade-enter-active, .fade-leave-active {
     transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
    }

    @media screen and (max-width: 1023px) {
        li.item {
        justify-content: space-between;
        align-items:flex-start;
        flex-wrap: wrap;
        margin-bottom: 1rem;
        }

        span.has-width-100 {
        display: block;
        }

        .emspace {
            display: none;
        }

        span.expand {
        flex: 1 1 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        }
    }

    @media screen and (max-width: 768px) {
        span.has-width-50 {
            min-width: initial;
            display: block;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Players/Relatives.vue